import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Homepage from './pages/homepage/homepage'
import './App.css';
import ServicesPage from './pages/servicesPage/servicesPage';
import ProductsPage from './pages/productsPage/productsPage';
import DescribeProductPage from './pages/describeProductPage/describeProductPage';
import ApplicationsPage from './pages/applicationsPage/applicationsPage';
import AboutUsPage from './pages/aboutUsPage/aboutUsPage';
import { SelectedLanguageContext, SelectedProductContext } from './contexts/siteContentsContext';
import React, { useState } from 'react';

function App() {
  const [selectedProduct, setSelectedProduct] = useState("");
  const languageSettings = JSON.parse(localStorage.getItem("languageSettings")) 
  const [selectedLanguage, setSelectedLanguage] = useState( languageSettings ? languageSettings :
    {
      srcLanguageFile: "/siteData/contentPT-BR.json",
      srcIcon: "/languageIcons/brazil.png",
      name: "pt-br",
      nameCompletName: "Português",
      alt: "Lingua selecionada - Português"
    }
  );
  

  return (
    <div className="App">
      <SelectedProductContext.Provider value={{selectedProduct, setSelectedProduct}}>
      <SelectedLanguageContext.Provider value={{selectedLanguage, setSelectedLanguage}}>
        
        <Router>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/services" element={<ServicesPage/>} />
            <Route path="/products" element={<ProductsPage/>} />
            <Route path={ "products/:id" + selectedProduct.name } element={<DescribeProductPage product={selectedProduct}/>} />
            <Route path="/applications" element={<ApplicationsPage/>} />
            <Route path="/aboutUs" element={<AboutUsPage/>} />
          </Routes>
        </Router>
        
        </SelectedLanguageContext.Provider>
        </SelectedProductContext.Provider>
        </div>
  );
}

export default App;
